
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import * as React from 'react';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineDot from '@mui/lab/TimelineDot';
import Timeline from '@mui/lab/Timeline';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import { I18n, useTranslation } from 'components/hooks/use-translation';
import ResponsiveContainer from 'components/atomic/organisms/responsive-container';
import MainLayout from 'components/layouts/main-layout';
import Text from 'components/atomic/atoms/text';
import Button from 'components/atomic/atoms/button';
import Link from 'next/link';
import Routes from 'utils/routes';
const Supporters = React.memo(() => {
    const { t }: I18n = useTranslation();
    const supporters = [
        {
            label: 'Venturin A. ✦ Bellino L. ✦ Mazzoni S.',
            date: 'Marzo 2023',
        },
        {
            label: 'Destefanis P. ✦ Sapino F. ✦ Bianchi A. ✦ Padovan M.',
            date: 'Febbraio 2023',
        },
        {
            label: 'Giardino M.',
            date: 'Gennaio 2023',
        },
    ];
    return (<MainLayout isFluid headerType="only-logo" title={t('supporters:pageTitle')}>
            <ResponsiveContainer maxWidth="md">
                <Stack pt={3} spacing={2} textAlign="center" alignItems="center">
                    <Text width={{ md: '90%' }} variant="h2">
                        {t('supporters:pageTitle')}
                    </Text>
                    <Text width={{ md: '85%' }}>{t('supporters:pageSubtitle')}</Text>
                </Stack>

                <Box mt={4}>
                    <Timeline>
                        {supporters.map((supporter, index) => (<TimelineItem key={index}>
                                <TimelineOppositeContent color="text.secondary">
                                    {supporter.date}
                                </TimelineOppositeContent>
                                <TimelineSeparator>
                                    <TimelineDot />
                                    {index !== supporters.length - 1 && <TimelineConnector />}
                                </TimelineSeparator>
                                <TimelineContent>{supporter.label}</TimelineContent>
                            </TimelineItem>))}
                    </Timeline>
                    <Box pt={2}>
                        <Alert variant="outlined" severity="info" icon={<TipsAndUpdatesIcon fontSize="small"/>}>
                            <AlertTitle>{t('supporters:alertTitle')}</AlertTitle>
                            <Stack direction={['column', 'row']} alignItems={['start', 'end']}>
                                <Text sx={{ flex: '1 1 auto', mb: [2, 0], mr: [0, 2] }} variant="body2">
                                    {t('supporters:alertSubtitle')}
                                </Text>
                                <Link href={Routes.Pricing} passHref>
                                    <a style={{ flex: 'none' }}>
                                        <Button variant="outlined" color="primary">
                                            {t('supporters:alertButton')}
                                        </Button>
                                    </a>
                                </Link>
                            </Stack>
                        </Alert>
                    </Box>
                </Box>
            </ResponsiveContainer>
        </MainLayout>);
});
const __Next_Translate__Page__18916ceb1e8__ = Supporters;

    export default __appWithI18n(__Next_Translate__Page__18916ceb1e8__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
    });
  